import { BankOutlined, CreditCardOutlined, DollarCircleOutlined } from '@ant-design/icons';
import { Button, Space } from 'antd';
import { PaymentTypes } from 'constants/payments';
import { useEffect, useState } from 'react';

interface PaymentMethodSelectorProps {
    value?: number;
    onSelected?: (paymentTypeId: number) => void;
    disabled?: boolean;
    availablePaymentTypes?: PaymentTypes[];
}

const PaymentMethodSelector = (props: PaymentMethodSelectorProps) => {
    const paymentTypes = props.availablePaymentTypes ?? [PaymentTypes.Cash, PaymentTypes.Transfer];
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(props.value ?? paymentTypes[0]);

    useEffect(() => {
        if (props.value !== undefined) {
            setSelectedPaymentMethod(props.value);
        }
    }, [props.value]);

    const handlePaymentMethodChange = (paymentMethod: number) => {
        if (props.disabled) {
            return;
        }

        setSelectedPaymentMethod(paymentMethod);
        props.onSelected?.(paymentMethod);
    };

    const options = [
        { id: PaymentTypes.Cash, label: 'Efectivo', icon: <DollarCircleOutlined /> },
        { id: PaymentTypes.Transfer, label: 'Pago electrónico', icon: <CreditCardOutlined /> },
        { id: PaymentTypes.Credit, label: 'Crédito', icon: <BankOutlined /> },
    ].filter(option => paymentTypes.includes(option.id));

    return (
        <div className="payment-method-selector">
            <Space size={30} wrap>
                {options.map(option => (
                    <Button
                        key={option.id}
                        type="text"
                        aria-label={option.label}
                        aria-pressed={selectedPaymentMethod === option.id}
                        disabled={props.disabled}
                        style={{
                            height: 'auto',
                            padding: '8px 12px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            color: selectedPaymentMethod === option.id ? 'green' : 'inherit',
                        }}
                        onClick={() => handlePaymentMethodChange(option.id)}>
                        <span style={{ fontSize: '30px' }}>{option.icon}</span>
                        <span style={{ fontSize: '14px' }}>{option.label}</span>
                    </Button>
                ))}
            </Space>
        </div>
    );
};

export default PaymentMethodSelector;
